import {
  FREE_TRIAL_IPB_EMAIL_ERROR,
  UPDATE_EMAIL_FREE_TRIAL_IPB,
  RESEND_EMAIL_FREE_TRIAL_IPB,
} from '_models/redux/types';

const initialState = {
  orders: [],
  total: 0,
  page: 1,
  limit: 10,
  loading: false,
  error: null,
};

const emailFreeTrialIpbReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_EMAIL_FREE_TRIAL_IPB:
    case RESEND_EMAIL_FREE_TRIAL_IPB:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case FREE_TRIAL_IPB_EMAIL_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default emailFreeTrialIpbReducer;
